function init() {
    const heroText = document.querySelector('.hero-text');

    if(heroText != null){
    
    const textData = heroText.getAttribute('data-hero-text').split(' | ')
    const typeDelay = 125 - (Math.random() * 50);
    const deleteDelay = 20;
    const carouselDelay = 3000;

    const typeWriter = async (index) => {
        let textIndex = 0;
        while(textIndex < textData[index].length) {
          await waitForMs(typeDelay);
          heroText.innerHTML = textData[index].substring(0, textIndex + 1);
          textIndex ++;
        }
        return;
    }

    const typeDeleter = async (index) => {
        while(heroText.innerHTML.length > 0) {
            await waitForMs(deleteDelay);
            heroText.innerHTML = heroText.innerHTML.substring(0, heroText.innerHTML.length - 1);
        }
        return;
    }

    const typeLooper = async (textData) => {
        let index = 0;
        while(true){
            await typeWriter(index);
            await waitForMs(carouselDelay);
            await typeDeleter(index);
            await waitForMs(typeDelay);
            index++
            if(index >= textData.length) {index = 0;}
        }
    }

    function waitForMs(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      }

      typeLooper(textData)
    
    }
}   

export { init as default };